import React from 'react'
import { FundItem } from '../../../../models/Fund';
import ContentBox from '../../../common/ContentBox';
import { Box, Divider, ITheme, Link, Typography, useTheme } from '@mui/material';
import FavoriteFundButton from '../../FavoriteFundButton';
import { useTranslation } from 'react-i18next';
import DataRoomArray from './DataRoomArray';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../../resources/routes-constants';

export interface IDataRoomTabContentProps {
    fund: FundItem;
}

const DataRoomTabContent: React.FC<IDataRoomTabContentProps> = ({ fund }) => {
    const { t } = useTranslation();
    const theme = useTheme() as ITheme;
    const navigate = useNavigate();

    const breakpoint = Math.floor((fund.dataRooms.length +1)/2);

    const showMore = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        navigate(AUTHENTICATED_ROUTES.LIBRARYOFFUNDS_ITEM_DATAROOM_ROUTE.replace(":id", `${fund.id}`))
    }

    return <ContentBox proportion={1}>
        <Box display={"flex"} flexDirection={"column"} gap={"5px"}>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('LibraryOfFundDataRoomsTabTitle')}</Typography>
                <Box display={"flex"} alignItems={"center"} gap={"20px"}>
                    <Link href={"#"} sx={{ textDecoration: "underline", color: theme.palette.leo.tone13}} onClick={showMore}>{t('LibraryOfFundDataRoomsTabSeeAllDocuments')}</Link>
                    <FavoriteFundButton fundId={fund.id} />
                </Box>
            </Box>
            <Divider sx={{ margin: "0 -32px"}} />
            <Box display={"flex"} alignItems={"flex-start"} gap={"67px"}>
                <DataRoomArray dataRooms={fund.dataRooms.slice(0, breakpoint)} />
                <Divider orientation="vertical" flexItem sx={{ margin: "35px 0 0 0"}} />
                <DataRoomArray dataRooms={fund.dataRooms.slice(breakpoint)} />
            </Box>
        </Box>
    </ContentBox>
}

export default DataRoomTabContent